<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadLease" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PASSCARD_PARAM"
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem['_licenseID']}">${helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum'])}</a>`;
    },
    form_hide: true, 
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'] || {};
      return `${dataItem.name || ''}<br>${dataItem.nationalID || ''}`;
    },
    form_hide: true, 
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_zoneName',
    text: 'Zone',
  },
  {
    key: '_productName',
    text: 'Product Name',
  },
  {
    key: 'commencementDate',
    text: 'Commencement Date',
    table_custom: helper.tableCustomDate,
  },
  {
    key: '_parkerInformation',
    text: 'Parker Information',
  },
  {
    key: 'passcardIssueDate',
    text: 'Date Passcard Issued',
    table_custom: helper.tableCustomDate,
  },
  {
    key: '_passcard',
    text: 'Passcard',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_passcard'];
      return (dataItem || {}).sku;
    },
    table_popup: true,
  },
  {
    key: '_printLetter',
    text: 'Print Letter',
    table_custom: () => 'Print Letter',
    table_popup: true,
  },
];


const PASSCARD_PARAM = [
  {
    key: 'sku',
    text: 'Passcard No.',
    form_input_attr: { disabled: true },
  },
  {
    key: 'movement',
    text: 'Movement',
    form_input_attr: { disabled: true },
  },
  {
    key: 'conditions',
    text: 'Status',
    form_input_attr: { disabled: true },
  },
  {
    key: 'isBlocked',
    text: 'Blocked',
    form_radio: [
      {1: 'Blocked'},
      {0: 'Not Blocked'},
    ],
    form_input_attr: { disabled: true },
  },
];

export default {
  name: "PagePasscardLetter",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Print Passcard Issuance Letter' },
      ],

      PARAM,

      PASSCARD_PARAM,

      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageLease: null,
      pageSeason: null,
      pageParker: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }

      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park application data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          let selection = this.pageCarpark;
          selection = [].concat({name: 'All Car Parks'}, selection);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(selection, this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No passcard available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue
      }
      url += '/license/';

      let feedbackItem = 'parking license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });

          if(response.data && response.data.length > 0) {
            // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);
            this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);
            this.loadZone();
          } else {
            this.$refs['licenseFilter'].setFilterError('No ' + feedbackItem + ' available');
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue
      }
      url += '/zone/';

      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadPasscard();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue
      }
      url += '/passcard/';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/lease?hasPasscardID=1';
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue
      }
      if(this.$refs['licenseFilter'].filterValue) {
        url += '&licenseID=' + this.$refs['licenseFilter'].filterValue
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageLease = response.data;//.filter(k => k.status === 'Active' && k.passcardID);
          this.pageLease.forEach(k => {
            k['_license'] = this.$refs['licenseFilter'].filterData.find(j => helper.compareID(j.id, k['licenseID'])) || {};
            k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
            k['_carparkName'] = (k['_carpark'] || {}).name;
            if(k['passcardID']) {
              let passcard = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
              if(passcard) {
                k['_passcard'] = passcard;
              }
            }
          });
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      this.pageLease.forEach(k => {
        k['_license'] = this.$refs['licenseFilter'].filterData.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseID'] = k['_license']['id'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];

        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']);
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;
      });
      this.$refs['pageTable'].setTableData(this.pageLease);
    },
    loadSeason() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue
      }
      url += '/season';

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let license = this.$refs['licenseFilter'].filterData.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
      let url = helper.SERVER_URL + '/api2';
      if(license && license['_customer']) {
        url += '/customer/' + license['_customer']['id']
      }
      url += '/parker';

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },


    onTablePageChange() {
      this.loadLease();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLease();
    },
    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },

    onTableDataClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let parameter = tableParameter[tableParameterIndex];
      let data = tableData[tableDataIndex];
      this.$refs['pageFeedback'].setFeedbackMessage();

      if(parameter.key === '_passcard') {
        this.$refs['pageModal'].setModalOpen(false, 'Passcard Status', data['_passcard']);
      } else if(parameter.key === '_printLetter') {
        this.preparePDF(data);
      }
    },
    preparePDF(dataItem) {
      this.loadCarparkFinance(dataItem);
      // if(dataItem['_customer']['isCompany']) {
      //   this.loadAddress(dataItem);
      // } else {
      //   this.loadAddress(dataItem);
      //   // let feedbackItem = 'license data';
      //   // this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      //   // this.$http
      //   //   .get(
      //   //     helper.SERVER_URL + '/api2/applicationData/' + dataItem['_license']['applicationData'],
      //   //     helper.createAxiosConfig()
      //   //   )
      //   //   .then(response => {
      //   //     let resultMeta = helper.processAxiosResponse(this, response);
      //   //     this.$refs['pageFeedback'].setFeedbackMessage();
      //   //     dataItem['print_license'] = response.data;
      //   //     this.loadAddress(dataItem);
      //   //   })
      //   //   .catch(error => {
      //   //     this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      //   //   });
      // }
    },
    loadCarparkFinance(dataItem) {
      let feedbackItem = 'car park detail data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + dataItem['_carpark']['id'] + '/finance',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          dataItem['_carparkFinance'] = response.data[0];
          this.loadCarparkAddress(dataItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarparkAddress(dataItem) {
      let feedbackItem = 'car park address data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + dataItem['_carpark']['addressData1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          dataItem['carpark_address'] = helper.parseAddress(response);
          this.loadAddress(dataItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadAddress(dataItem) {
      let feedbackItem = 'address data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + dataItem['_customer']['address1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          dataItem['print_address'] = helper.parseAddress(response);
          this.loadAddressDetail(dataItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    async loadAddressDetail(dataItem) {
      let addressCityKey = (dataItem['_customer']['isCompany'] || dataItem['_license']['addressOpt1'] === 1) ? 'companyAddressCityID' : 'personalCorrespondenceAddressCityID';
      if(dataItem['print_address'] && dataItem['print_address'][addressCityKey]) {
        let customerAddress = dataItem['print_address'];
        customerAddress['city'] = await this.$http
          .get(
            helper.SERVER_URL + '/api2/city/' + customerAddress[addressCityKey],
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            return response.data[0]
          })

          if(customerAddress['city']) {
            customerAddress['state'] = await this.$http
              .get(
                helper.SERVER_URL + '/api2/state/' + customerAddress['city'].stateID,
                helper.createAxiosConfig()
              )
              .then(response => {
                let resultMeta = helper.processAxiosResponse(this, response);
                return response.data[0]
              })

            if(customerAddress['state']) {
              customerAddress['country'] = await this.$http
                .get(
                  helper.SERVER_URL + '/api2/country/' + customerAddress['state'].countryID,
                  helper.createAxiosConfig()
                )
                .then(response => {
                  let resultMeta = helper.processAxiosResponse(this, response);
                  return response.data[0]
                })
            }
          }
      }

      this.getHeaderImageData(dataItem);
    },
    getHeaderImageData(dataItem) {
      if(dataItem['_carparkFinance'] && dataItem['_carparkFinance']['logoHeader1']) {
        var img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        
        let that = this;
        img.onerror = function () {
          that.$refs['pageFeedback'].setFeedbackError('Problem loading car park header');
        }
        img.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(this, 0, 0);

          var dataURL = canvas.toDataURL("image/png");

          dataItem['image'] = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
          that.$refs['pageFeedback'].setFeedbackMessage();
          that.printPDF(dataItem);
        };

        img.src = dataItem['_carparkFinance']['logoHeader1'];
        this.$refs['pageFeedback'].setFeedbackLoading('Loading car park header');
      } else {
        this.printPDF(dataItem);
      }
    },
    printPDF(dataItem) {
			var doc = new jsPDF('p', 'pt', 'a4', true);
			doc.setFontSize(10);
      var rowPerPage = 17;
      
      var imageData = dataItem['image'];
      
			var marginTopInitial = 40;
			var marginTop = marginTopInitial;
			var marginLeft = 40;
			var fullPageHeight = doc.internal.pageSize.getHeight() - marginTopInitial - marginTopInitial;
      var fullPageWidth = doc.internal.pageSize.getWidth() - marginLeft - marginLeft;
      let sectionHeight = fullPageHeight / 3;
      
      let imageHeight = 35;
      if(imageData) {
        doc.addImage(imageData, 'JPEG', marginLeft, marginTop, fullPageWidth, imageHeight);
      }
      marginTop += imageHeight;
      
			marginTop += 60;
      doc.text(doc.splitTextToSize('With Monthly Parking, you can access your applied car park (according to TNC) with a personal passcard.\nPlease contact our number on ' + (dataItem['carpark_address']['phone1'] || '-') + ' immediately if you received this card carrier without your access card.', fullPageWidth - 10), marginLeft, marginTop);
			marginTop += 60;
      // doc.text(doc.splitTextToSize('Please call our Care Line on 1-300-88-1698 immediately if you received this card carrier without your parking access card.', fullPageWidth - 10), marginLeft, marginTop);
      
      marginTop += 20;
      marginTop = sectionHeight;
      doc.line(marginLeft, marginTop, marginLeft + fullPageWidth, marginTop);
      marginTop += 20;

      let leftSquareWidth = 150;
      let leftSquareHeight = 200;
      let rightSquareWidth = fullPageWidth - leftSquareWidth - 40;
      doc.rect(marginLeft, marginTop, leftSquareWidth, leftSquareHeight);
      doc.rect(fullPageWidth - rightSquareWidth + marginLeft, marginTop, rightSquareWidth, leftSquareHeight);

			doc.setFontType("bold");
      doc.text('Your card is ready!', marginLeft + 10, marginTop + 20);

      let text = 'Place card here';
      doc.text(text, fullPageWidth - (rightSquareWidth/2), marginTop + (leftSquareHeight/2));

			doc.setFontType("normal");
      // doc.text(doc.splitTextToSize('Visit parkbills.parkaidemobile.com for more details.', leftSquareWidth - 20), marginLeft + 10, marginTop + leftSquareHeight - 60);

      marginTop += leftSquareHeight;
      marginTop += 20;
      doc.setLineWidth(5)
      marginTop = sectionHeight * 2;
      doc.line(marginLeft, marginTop, marginLeft + fullPageWidth, marginTop);
      doc.setLineWidth(1)
      marginTop += 20;

      let cell2Width = 100;
      let cell3Width = 100;
      let cell4Width = 80;
      let cell1Width = fullPageWidth - cell2Width - cell3Width - cell4Width;
      let cellHeight = 20;

			doc.setFontType("bold");
      doc.setDrawColor(255);
      doc.cellInitialize();
      doc.cell(marginLeft, marginTop, cell1Width, cellHeight, 'Parker\'s Name', 0);
      doc.cell(marginLeft, marginTop, cell2Width, cellHeight, 'PL Number', 0);
      doc.cell(marginLeft, marginTop, cell3Width, cellHeight, 'Card No', 0);
      doc.cell(marginLeft, marginTop, cell4Width, cellHeight, 'Date Issued', 0);
      marginTop += cellHeight;

			doc.setFontType("normal");
      doc.cellInitialize();
      doc.cell(marginLeft, marginTop, cell1Width, cellHeight, doc.splitTextToSize(dataItem['_parker']['name'], cell1Width - 5), 0);
      doc.cell(marginLeft, marginTop, cell2Width, cellHeight, doc.splitTextToSize(helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum']), cell2Width), 0);
      doc.cell(marginLeft, marginTop, cell3Width, cellHeight, doc.splitTextToSize(dataItem['_passcard']['sku'], cell3Width - 5), 0);
      doc.cell(marginLeft, marginTop, cell4Width, cellHeight, helper.formatDate(dataItem['passcardIssueDate']), 0);
      marginTop += cellHeight;

      marginTop += 40;
      doc.setDrawColor(0);
      let bottomSquareWidth = 150;
      let bottomSquareHeight = 150;
      doc.rect(fullPageWidth - bottomSquareWidth + marginLeft, marginTop, bottomSquareWidth, bottomSquareHeight);

      doc.text(doc.splitTextToSize('The use of your access card is subject to the Terms and Conditions (as may be amended or supplemented from time to time). Retention and/or use of your parking access card shall be deemed to be confirmation of your agreement to be bound by the same.', bottomSquareWidth - 20), fullPageWidth - bottomSquareWidth + marginLeft + 10, marginTop + 20);

      marginTop += 60;
      let lineHeight = 15;
      doc.text(dataItem['_parker']['name'], marginLeft, marginTop);
      marginTop += lineHeight;

      let temp = [];
      let addressKey = '';
      if(dataItem['_customer']['isCompany'] || dataItem['_license']['addressOpt1'] === 1) {
        addressKey = 'companyAddress';
      } else {
        addressKey = 'personalCorrespondenceAddress';
      }
      let address = dataItem['print_address']
      if(address[addressKey + '1']) {
        temp.push(address[addressKey + '1'] + ',');
      }
      if(address[addressKey + '2']) {
        temp.push(address[addressKey + '2'] + ',');
      }
      if(address[addressKey + '3']) {
        temp.push(address[addressKey + '3'] + ',');
      }
      let temp1 = '';
      if(address[addressKey + 'PostalCode']) {
        temp1 += address[addressKey + 'PostalCode'] + ' ';
      }
      if(address['city'] && address['city'].name) {
        temp1 += address['city'].name;
      }
      if(temp1) {
        temp.push(temp1 + ',');
      }
      let temp2 = '';
      if(address['state'] && address['state'].name) {
        temp2 += address['state'].name + ', ';
      }
      if(address['country'] && address['country'].name) {
        temp2 += address['country'].name;
      }
      if(temp2) {
        temp.push(temp2);
      }

      for(let a of temp) {
        doc.text(a, marginLeft, marginTop);
        marginTop += lineHeight;
      }
			
			doc.save('Passcard Issuance Letter ' + helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum']) + ' ' + dataItem['_parker']['name'] + '.pdf');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscardLetter.vue